/* eslint-disable import/prefer-default-export */
export function processDocRequestLogs( logs: Object[] ): Object[] {
  if ( !logs || logs.length === 0 ) {
    return [];
  }

  const sortedLogs = [...logs].sort(
    ( a: any, b: any ) => new Date( a.fechaAccion ).getTime() - new Date( b.fechaAccion ).getTime(),
  );

  const fieldsToMonitor = [
    'nombre',
    'descripcion',
    'fechaLimite',
    'fechaExpiracion',
    'estado',
    'activo',
    'nombreArchivo',
    'urlArchivo',
    'tipoArchivo',
  ] as const;

  const accumulatorInitialValue = { processedLogs: [], previousLog: null };

  const { processedLogs } = sortedLogs.reduce( ( acc: any, currentLog ) => {
    const newLog: any = { ...currentLog };

    if ( acc.previousLog ) {
      fieldsToMonitor.forEach( ( field ) => {
        const currentValue = newLog[field];
        const previousValue = acc.previousLog[field];

        if ( JSON.stringify( currentValue ) === JSON.stringify( previousValue ) ) {
          newLog[field] = undefined;
        }
      } );
    }

    return {
      processedLogs: [...acc.processedLogs, newLog],
      previousLog: currentLog,
    };
  }, accumulatorInitialValue as any ); // Usamos aserciones 'as any' en el acumulador.

  return processedLogs.reverse();
}
